import {
  TLineSetupTicketId,
  TRESPONSE_FLOATING_AREAS_FOR_LOCATION_DELETION,
  TRESPONSE_GET_ALL_SHIFT_SCHEDULE_LINE_LOCATIONS,
  TRESPONSE_GET_ALL_WORKSTATIONS_FOR_PRODUCTION_AREA,
  TRESPONSE_GET_FACTORY_LINE_WORKSTATION_SUMMARY_LIST,
} from '@monorepo/types';
import { TLocationManagementGetFloatingAreaActionTypes } from '../location-management/location-management.models';

export type TLineSetUpState = {
  productionAreaWorkStations: TRESPONSE_GET_ALL_WORKSTATIONS_FOR_PRODUCTION_AREA | null;
  floatingAreaFloorsForLocationDeletion: TRESPONSE_FLOATING_AREAS_FOR_LOCATION_DELETION | null;
  factoryLineWorkstationSummaryList: TRESPONSE_GET_FACTORY_LINE_WORKSTATION_SUMMARY_LIST | null;
  factoryLinesForShiftManagement: TRESPONSE_GET_ALL_SHIFT_SCHEDULE_LINE_LOCATIONS | null;
};

type TWorkstaionListFetchContext = {
  fetchContext: 'WORKSTATION_LISTING';
  locationId: number;
};

type TRedirectMachineIssueTicketFetchContext = {
  fetchContext: 'REDIRECT_MACHINE_ISSUE_TICKET';
};

type TLineSetupTicketSubtaskListingFetchContext = {
  fetchContext: 'LINE_SETUP_TICKET_SUBTASK_LISTING';
  lineSetupTicketId: TLineSetupTicketId;
};

type TLineSetupTicketDetailsFetch = {
  fetchContext: 'LINE_SETUP_TICKET_DETAILS_FETCH';
  locationId: number;
};

export type TLineSetupActionsReplaceMachineFetchPayload =
  | TWorkstaionListFetchContext
  | TRedirectMachineIssueTicketFetchContext
  | TLineSetupTicketSubtaskListingFetchContext;

export type TLineSetupActionsRemoveMachineFetchPayload =
  | TWorkstaionListFetchContext
  | TLineSetupTicketSubtaskListingFetchContext;

export type TLineSetupActionsAssignMachineFetchPayload =
  | TWorkstaionListFetchContext
  | TLineSetupTicketSubtaskListingFetchContext;

export type TLineSetupActionsEditWorkstationFetchPayload = TWorkstaionListFetchContext | TLineSetupTicketDetailsFetch;

export const TLineSetUpActionType = {
  ...TLocationManagementGetFloatingAreaActionTypes,
  GetFactoryLineWorkstationSummaryList: 'GET_FACTORY_LINE_WORKSTATION_SUMMARY_LIST' as const,
  GetFactoryLineWorkstationSummaryListSuccess: 'GET_FACTORY_LINE_WORKSTATION_SUMMARY_LIST_SUCCESS' as const,
  GetFactoryLineWorkstationSummaryListFailure: 'GET_FACTORY_LINE_WORKSTATION_SUMMARY_LIST_FAILURE' as const,
  AddNewWorkstation: 'ADD_NEW_WORKSTATION' as const,
  AddNewWorkstationSuccess: 'ADD_NEW_WORKSTATION_SUCCESS' as const,
  AddNewWorkstationFailure: 'ADD_NEW_WORKSTATION_FAILURE' as const,
  GetAllWorkstationsForProductionArea: 'GET_ALL_WORKSTATIONS_FOR_PRODUCTION_AREA' as const,
  GetAllWorkstationsForProductionAreaSuccess: 'GET_ALL_WORKSTATIONS_FOR_PRODUCTION_AREA_SUCCESS' as const,
  GetAllWorkstationsForProductionAreaFailure: 'GET_ALL_WORKSTATIONS_FOR_PRODUCTION_AREA_FAILURE' as const,
  AssignMachineToWorkstation: 'ASSIGN_MACHINE_TO_WORKSTATION' as const,
  AssignMachineToWorkstationSuccess: 'ASSIGN_MACHINE_TO_WORKSTATION_SUCCESS' as const,
  AssignMachineToWorkstationFailure: 'ASSIGN_MACHINE_TO_WORKSTATION_FAILURE' as const,
  RemoveMachineFromWorkstation: 'REMOVE_MACHINE_FROM_WORKSTATION' as const,
  RemoveMachineFromWorkstationSuccess: 'REMOVE_MACHINE_FROM_WORKSTATION_SUCCESS' as const,
  RemoveMachineFromWorkstationFailure: 'REMOVE_MACHINE_FROM_WORKSTATION_FAILURE' as const,
  ReplaceMachine: 'REPLACE_MACHINE' as const,
  ReplaceMachineSuccess: 'REPLACE_MACHINE_SUCCESS' as const,
  ReplaceMachineFailure: 'REPLACE_MACHINE_FAILURE' as const,
  RemoveWorkstation: 'REMOVE_WORK_STATION' as const,
  RemoveWorkstationSuccess: 'REMOVE_WORK_STATION_SUCCESS' as const,
  RemoveWorkstationFailure: 'REMOVE_WORK_STATION_FAILURE' as const,
  ResetFactoryProductionArea: 'RESET_FACTORY_PRODUCTION_AREA' as const,
  ResetFactoryProductionAreaSuccess: 'RESET_FACTORY_PRODUCTION_AREA_SUCCESS' as const,
  ResetFactoryProductionAreaFailure: 'RESET_FACTORY_PRODUCTION_AREA_FAILURE' as const,
  GetFactoryLinesForShiftManagement: 'GET_FACTORY_LINES_FOR_SHIFT_MANAGEMENT' as const,
  GetFactoryLinesForShiftManagementSuccess: 'GET_FACTORY_LINES_FOR_SHIFT_MANAGEMENT_SUCCESS' as const,
  GetFactoryLinesForShiftManagementFailure: 'GET_FACTORY_LINES_FOR_SHIFT_MANAGEMENT_FAILURE' as const,
  AddMachineNeedles: 'ADD_MACHINE_NEEDLES' as const,
  AddMachineNeedlesSuccess: 'ADD_MACHINE_NEEDLES_SUCCESS' as const,
  AddMachineNeedlesFailure: 'ADD_MACHINE_NEEDLES_FAILURE' as const,
  RemoveMachineNeedles: 'REMOVE_MACHINE_NEEDLES' as const,
  RemoveMachineNeedlesSuccess: 'REMOVE_MACHINE_NEEDLES_SUCCESS' as const,
  RemoveMachineNeedlesFailure: 'REMOVE_MACHINE_NEEDLES_FAILURE' as const,
};
